import Vue from 'vue';

export function validateRules(rules, value) {
    let messages = [];
    rules = rules || [];

    for (let rule of rules) {
        let message = validateRule(rule, value);
        if (message !== true) {
            messages.push(message);
        }
    }
    return messages;
}

export function validateRule(args, value) {
    /*
     * a rule can be a string or an array where the rule name is the first element and the leftover element are the
     * arguments
     */
    let rule;
    let msg;
    let params = [];

    if (args instanceof Array) {
        args = args.slice(0);
        rule = args.shift();
    } else {
        rule = args;
        args = [];
    }

    /*
     * value has to be a string
     */
    value += "";

    /*
     * switch validation logic by rule name. Return true if valid or error message as string if invali
     *
     */
    let min, max, length;
    switch (rule) {
        case 'email':
            if (!/[^@]*@.*/.test(value)) {
                msg = "invalid_email";
            }
            break;
        case 'length':
            min = args[0];
            max = args[1];
            length = value.length;

            switch (true) {
                case min === null && max === null:
                    break;
                case min === null && max !== null && length > max:
                    msg = "invalid_length_max";
                    params = [max];
                    break;
                case min !== null && max === null && length < min:
                    msg = "invalid_length_min";
                    params = [min];
                    break;
                case min !== null && max !== null && (length > max || length < min):
                    msg = "invalid_length";
                    params = [min, max];
                    break;
            }
    }
    return typeof msg === "string" ? sprintf(Vue.__(['validation', msg]), params) : true;
}

export function sprintf(format) {
    let args = Array.prototype.slice.call(arguments, 1);
    let i = 0;
    return format.replace(/%s/g, function() {
        return args[i++];
    });
}

export function checkConditions(conditions, values) {
    conditions = conditions || [];
    for (let condition of conditions) {
        if (!checkCondition(condition, values)) {
            return false;
        }
    }
    return true;
}

export function checkCondition(condition, values) {
    /*
     * a condition is always an array with 3 elements: name, comparator, value
     */
    if (condition.length < 3) {
        throw "Field Condition need to have atleast 3 items.";
    }
    let [name, comparator, value] = condition;
    let actual_value = values[name];

    /*
     * switch comparison logic my comparator
     */
    switch (comparator) {
        case '==': return actual_value == value;
        case '!=': return actual_value != value;
        case '===': return actual_value === value;
        case '!==': return actual_value !== value;
        case 'in': return !!~value.indexOf(actual_value);
        case 'not in': return !~value.indexOf(actual_value);
        case 'has': return  value.some(r => actual_value.includes(r));
    }
    throw "Unknown comparator";
}

export function getScrollingElement() {
    if (typeof document.scrollingElement !== "undefined") {
        return document.scrollingElement;
    }
    if ('WebkitAppearance' in document.documentElement.style) {
        return document.body;
    }
    return  document.documentElement;
}

export function clone(obj) {
    let clone = {};
    for (let key of Object.keys(obj)) {
        clone[key] = obj[key];
    }
    return clone;
}

export function stripHtml(string) {
    return (string || "").replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "");
}

export const domain = (() => {
  let match = location.hostname.match(/([^.]+\.[^.0-9]+)$/);
  return match ? match[1] : location.hostname;
})();

export function getCookie(name, defaultValue = null) {
  let match = document.cookie.match(new RegExp(`(?:^|;\\s)${name}=([^;$]+)`));
  return match ? match[1] : defaultValue;
}

export function setCookie(name, value, {lifetime = "session", encodeValue = true} = {}) {
  if (encodeValue) {
    value = encodeURIComponent(value);
  }
  let cookie = `${name}=${value}`;
  if (lifetime !== null && lifetime !== "session") {
    let expiry = new Date(Date.now() + lifetime * 86400000);
    cookie += `;expires=${expiry.toUTCString()}`;
  }
  document.cookie = `${cookie}; path=/; domain=${domain};`;
}

export function removeCookie(name) {
  document.cookie = `${name}= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain};`;
}

const randomAlphaNumChars = [...Array(36).keys()].map(v => v.toString(36));
export function randomHash(length = 8, avoidCollision, recursionCount = 0) {
  let hash = [...Array(length).keys()]
    .map(() => randomAlphaNumChars[Math.floor(Math.random() * randomAlphaNumChars.length)])
    .join("");
  if (Array.isArray(avoidCollision) && avoidCollision.includes(hash)) {
    recursionCount++;
    if (recursionCount > 1000) {
      throw "max randomHash recursion limit reached";
    }
    return randomHash(length, avoidCollision, recursionCount);
  }
  return hash;
}

export function makeRoute(path, name, component, meta={}) {
    return {name, path, component, meta, props: true};
}

